<template>
	<ImageAndContent
		content-column-class="flex items-center"
		content-column-width="w-full lg:w-3/5"
		image-column-width="w-full lg:w-2/5"
		image-column-padding="pl-0"
	>
		<template #content>
			<div>
				<h2>What are the benefits of car subscription?</h2>
				<div class="text-lg text-gray-575">
					After property, a car may be the second most expensive
					purchase a person will ever make. However, unlike property,
					which has historically gone up in value in Australia, cars
					usually depreciate and add significant costs for you every
					day.
				</div>
			</div>
		</template>
		<template #image>
			<div class="mb-4 mt-4 w-full lg:m-0">
				<CarbarImage
					image="img/car-subscription/img-what_is_the_benefits.webp"
					alt-text="What is the benefits of subscribing"
				/>
			</div>
		</template>
	</ImageAndContent>

	<div
		class="flex flex-col space-y-8 lg:mt-10 lg:flex-row lg:space-x-8 lg:space-y-0"
	>
		<div v-for="(item, key) in items" :key="key" class="w-full lg:w-1/3">
			<h3 class="font-body font-medium">
				{{ item.title }}
			</h3>
			<div class="text-lg text-gray-575">{{ item.content }}</div>
		</div>
	</div>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import ImageAndContent from '@/components/sections/ImageAndContent.vue'

const items = [
	{
		title: 'Hassle-free convenience',
		content:
			'We’ll take care of all the admin and risks associated with car ownership so you can focus more on the things that matter to you.',
	},
	{
		title: 'Complete peace of mind',
		content: `We've got you covered with 24/7 roadside assistance which is included as part of your subscription fee. We will ensure we keep you mobile so there's no need to stress.`,
	},
	{
		title: 'Flexibility to stop or swap',
		content:
			'A car should give you the ultimate freedom, not burden you with bills and debt. Take the hassle, stress and uncertainty out of owning a car.',
	},
]
</script>
